<template>
  <svg :class="`icon-sprite icon-sprite-${name}`" @click="$emit('click', $event)" @mousedown="$emit('mousedown', $event)">
    <use :xlink:href="`#icon-${name}`"></use>
  </svg>
</template>

<script>
/**
 * 定义class width height color 即可完成定制
 * @click
 * @mousedown
 */
export default {
  name: 'v-icon',
  props: {
    name: String
  }
}
</script>

<style scoped lang="less">
.icon-sprite {
  width: 20px;
  height: 20px;
  fill: currentColor;
  vertical-align: -0.15em;
  overflow: hidden;
  font-size: inherit;
  line-height: inherit;
}
</style>
